import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';

@Component({
  selector: 'app-phrclinicalsummaries',
  templateUrl: './phrclinicalsummaries.component.html',
  styleUrls: ['./phrclinicalsummaries.component.scss'],
  providers: [AppService, IceNavService]
})
export class PhrclinicalsummariesComponent implements OnInit {

  constructor(private appSvc: AppService, private loginSvc: LoginService, private navSvc: IceNavService) {
    this.appSvc.defaultMenus();
    this.appSvc.addBreadcrumb("Clinical Summaries", {}, true, "");
  }

  ngOnInit() {
    this.appSvc.refreshMenus();
  }
}
